import { REGEX_VALID_IMAGE } from "../constants/regex.constants";

export const validateURL = (url?: string) => {
  if (!url || (url && !REGEX_VALID_IMAGE.test(url))) return ''
  return url
}

export const isValidHttpsUrl = (url?: string): boolean => {
  try {
    if (!url) return false
    const parsed = new URL(url);
    return parsed.protocol === 'https:';
  } catch {
    return false;
  }
}
